'use client';

import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { EColors } from '@/_types';
import { BrowserLink } from '@/_kit/browser-link';
import { ArrowRightIcon } from '@/_kit/icons/arrow-right-icon';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { ETextSize } from '@/_kit/text/_types';
import { Text } from '@/_kit/text';
import { TLink } from '@/_components/development-with-wb/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Link';

type TProps = TLink & { size: ETextSize };

export const Link = ({ text, route, size }: TProps) => {
  const translations = useTranslations();
  const sendEvent = useAnalytics();

  const handleClick = () => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_ABOUT_WB_INFO_BUTTON_T,
      params: {
        // eslint-disable-next-line camelcase
        button_name: 'map_delivery',
      },
    };

    sendEvent(config);
  };

  return (
    <div className={cn(BLOCK_NAME)}>
      <BrowserLink
        color={EColors.BLUE_500}
        onClick={handleClick}
        rightIcon={ArrowRightIcon}
        routeName={route}
        target="_blank"
      >
        <Text size={size} text={translations(text)} variant="body" />
      </BrowserLink>
    </div>
  );
};
